
import axios, { AxiosInstance } from 'axios';
import { getExhibitionHeader } from "../utils/exhibitionContext";

export interface Exhibition {
  id: number;
  title: string;
  exhibition_type: number;
  venue: string;
  start_date: string;
  end_date: string;
  description: string;
  phone_number: number;
  email: string;
  status: boolean;
  
}

const api: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://127.0.0.1:8000",
  headers: {
    'Content-Type': 'application/json',
  },
});

// ✅ Dynamically attach token before each request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    Object.assign(config.headers, getExhibitionHeader());
    }
    return config;
  },
  (error) => Promise.reject(error)
);

interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  total_pages: number;
  current_page: number;
  page_size: number;
  results: T[];
}

const ExhibitionService = {
  getAll: async (): Promise<PaginatedResponse<Exhibition>> => {
    const response = await api.get('/api/exhibitions/exhibitions/');
    return response.data;
  },

 getById: async (id: number): Promise<Exhibition> => {
    const response = await api.get(`/api/exhibitions/exhibitions/${id}/`)
    return response.data
  },

  async create(data: Omit<Exhibition, 'id'>): Promise<Exhibition> {
    const response = await api.post('/api/exhibitions/exhibitions/create/', data);
    return response.data;
  },

  async update(id: number, data: Omit<Exhibition, 'id'>): Promise<Exhibition> {
    const response = await api.put(`/api/exhibitions/exhibitions/${id}/update/`, data);
    return response.data;
  },

  


  async delete(id: number): Promise<void> {
    await api.delete(`/api/exhibitions/exhibitions/${id}/delete/`);
  },
};

export default ExhibitionService;
